export const SET_DADOS_AGENDA = 'CONFIGURACOES/AGENDA/SET_DADOS_AGENDA'
export const SET_DADOS_FORMULARIO_AGENDA = 'CONFIGURACOES/AGENDA/SET_DADOS_FORMULARIO_AGENDA'
export const SET_RESETAR_DADOS_AGENDA = 'CONFIGURACOES/AGENDA/SET_RESETAR_DADOS_AGENDA'
export const SET_HABILITAR_OU_DESABILITAR_CALDAV = 'CONFIGURACOES/AGENDA/SET_HABILITAR_OU_DESABILITAR_CALDAV'
export const SET_FLAGS_DE_CONTROLE = 'CONFIGURACOES/SET_FLAGS_DE_CONTROLE'
export const SET_DADOS_RETORNO_CADASTRO = 'CONFIGURACOES/SET_DADOS_RETORNO_CADASTRO'
